import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import {
	Button,
	Card, CardActions, CardHeader, CardMedia, makeStyles,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Launch } from '@material-ui/icons';
import { useFirestoreCollectionRT } from '../hooks/firebase';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		paddingBottom: theme.spacing(3),
	},
	card: {
		margin: theme.spacing(1),
	},
	cardMedia: {},
	cardHeader: {},
	cardActions: {},
}));

export default function Home(props) {
	const { className } = props;

	const classes = useStyles();
	const boards = useFirestoreCollectionRT('boards');

	return (
		<div className={clsx(classes.root, className)}>
			{boards && Object.entries(boards).map(([boardId, board]) => (
				<Card key={boardId} className={classes.card}>
					<CardMedia
						className={classes.cardMedia}
						// image={image}
					/>
					<CardHeader
						className={classes.cardHeader}
						title={`${board.name} (${board.type})`}
						subheader={`Id: ${boardId}`}
					/>
					<CardActions className={classes.cardActions}>
						<Link to={`/b/${boardId}`}>
							<Button endIcon={<Launch />}>Launch</Button>
						</Link>
					</CardActions>
				</Card>
			))}
		</div>
	);
}

Home.defaultProps = {
	className: undefined,
};

Home.propTypes = {
	className: propTypes.string,
};
